import React, { useEffect } from "react";
import { OnboardingAxios, ProgramSetupAxios } from "../../../../API";
import DataTable from "../DataTable/DataTable";
import { Button, Modal } from "react-bootstrap";
import ExportExcel from "../Exports/ExportExcel";

const Registrations = (props) => {
    const [usersList, setUsersList] = React.useState([]);
    const [tableData, setTableData] = React.useState({});
    const [teams, setTeams] = React.useState([]);
    const [preferredMission, setPreferredMission] = React.useState([]);
    const roleLabels = { 3: 'Admin', 4: 'Learner', 5: 'Coach' };
    const [filters, setFilters] = React.useState({});
    const [filterData, setFilterData] = React.useState([]);

    useEffect(() => {
        getSAPUsers();
    }, [props.selectedOffering]);

    useEffect(() => {
        generateTableData();
    }, [usersList, teams, preferredMission]);

    const getSAPUsers = () => {
        ProgramSetupAxios.post("/EligiblePool/geteligibleuserbyoffering/" + props.selectedOffering)
            .then(function (response) {
                setUsersList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        ProgramSetupAxios.get("/OfferingMission/getmissionsbyoffering/" + props.selectedOffering)
            .then(function (response) {
                setPreferredMission(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

        getTeams();
    };

    const getTeams = () => {
        OnboardingAxios.get("/Team?includeConclaves=true&onlyConclaves=false")
            .then(function (response) {
                setTeams(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const generateTableData = () => {

        let roles = usersList.map((x) => {
            let label = roleLabels[x.role];
            return { value: x.role, label: label };
        });
        const ids = roles.map(o => o.value);
        roles = roles.filter(({ value }, index) => !ids.includes(value, index + 1));

        let columns = [
            {
                label: "Offering Name",
                field: 'offeringName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Offering Name',
                    className: 'text-center',
                },
                sort: true,
                filter: true,
                filterType: 'text',
            },
            {
                label: "First Name",
                field: 'firstName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Last Name",
                field: 'lastName',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Email",
                field: 'email',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Email',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Offering Portfolio",
                field: 'offeringPortfolio',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Offering Portfolio',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Offering",
                field: 'offering',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Offering',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Location",
                field: 'location',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Location',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Industry",
                field: 'industry',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'industry',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Region/Geography",
                field: 'geography',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Region/Geography',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Job Level",
                field: 'jobLevel',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Job Level',
                },
                sort: true,
                filter: true,
                filterType: 'text',

            },
            {
                label: "Role",
                field: 'role',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Role',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...roles,
                ],

            },
            {
                label: "Preferred Mission",
                field: 'preferredMission',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'PreferredMission',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...preferredMission.map((x) => {
                        return { value: x.id, label: x.missionName };
                    }),
                    { value: 0, label: 'Blank' },
                ]

            },
            {
                label: "Team",
                field: 'teamId',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'TeamId',
                },
                sort: true,
                filter: true,
                filterType: 'select',
                filterList: [
                    { value: '', label: '-' },
                    ...teams.filter(obj => obj.isConclave === false)
                        .map((x) => {
                            return { value: x.id, label: x.teamName };
                        }),
                    { value: 0, label: 'Blank' },
                ]
            },
        ];
        let rows = [];
        usersList.forEach((user) => {
            let row = {};
            let mission = preferredMission.find(x => x.id === user.preferredMission);
            let team = teams.find(x => x.id === user.teamId);
            let offeringName = props.selectedOfferingName;

            row.id = { value: user.id, label: user.id, export: user.id };
            row.offeringName = { value: offeringName, label: offeringName, export: offeringName };
            row.firstName = { value: user.firstName, label: user.firstName, export: user.firstName };
            row.lastName = { value: user.lastName, label: user.lastName, export: user.lastName };
            row.email = { value: user.email, label: user.email, export: user.email };
            row.offeringPortfolio = { value: user.portfolio, label: user.portfolio, export: user.portfolio };
            row.offering = { value: user.offering, label: user.offering, export: user.offering };
            row.location = { value: user.location, label: user.location, export: user.location };
            row.industry = { value: user.industry, label: user.industry, export: user.industry };
            row.geography = { value: user.geography, label: user.geography, export: user.geography };            
            row.jobLevel = { value: user.jobLevel, label: user.jobLevel, export: user.jobLevel };
            row.role = { value: user.role, label: roleLabels[user.role], export: roleLabels[user.role] };
            row.preferredMission = {
                value: user.preferredMission,
                label: mission
                    ? mission.missionName
                    : '-',
                export: mission && mission.missionName
            };
            row.teamId = {
                value: user.teamId,
                label: team
                    ? team.teamName
                    : '-',
                export: team && team.teamName
            };
             rows.push(row);
        });
        
        setTableData({ columns, rows });
    };


    return (
        <>
            <div className="page-header mb-4">
                {/* <h1>Reports</h1> */}
                <div className="page-actions">
                    <ExportExcel jsonObject={filterData} />
                </div>
            </div>
            <div className="data-table">
                <DataTable {...tableData} setFilters={setFilters} filters={filters} setFilterData={setFilterData} />
            </div>
        </>
    );
};

export default Registrations;
